import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Translations\SyncTranslationsController::__invoke
* @see app/Http/Controllers/Api/Translations/SyncTranslationsController.php:19
* @route '/api/translations/sync/{language}'
*/
export const sync = (args: { language: string | number } | [language: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sync.url(args, options),
    method: 'get',
})

sync.definition = {
    methods: ["get","head"],
    url: '/api/translations/sync/{language}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Translations\SyncTranslationsController::__invoke
* @see app/Http/Controllers/Api/Translations/SyncTranslationsController.php:19
* @route '/api/translations/sync/{language}'
*/
sync.url = (args: { language: string | number } | [language: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { language: args }
    }

    if (Array.isArray(args)) {
        args = {
            language: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        language: args.language,
    }

    return sync.definition.url
            .replace('{language}', parsedArgs.language.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Translations\SyncTranslationsController::__invoke
* @see app/Http/Controllers/Api/Translations/SyncTranslationsController.php:19
* @route '/api/translations/sync/{language}'
*/
sync.get = (args: { language: string | number } | [language: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sync.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Translations\SyncTranslationsController::__invoke
* @see app/Http/Controllers/Api/Translations/SyncTranslationsController.php:19
* @route '/api/translations/sync/{language}'
*/
sync.head = (args: { language: string | number } | [language: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sync.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\Translations\TranslationController::index
* @see app/Http/Controllers/Api/Translations/TranslationController.php:17
* @route '/api/translations'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/api/translations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Translations\TranslationController::index
* @see app/Http/Controllers/Api/Translations/TranslationController.php:17
* @route '/api/translations'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Translations\TranslationController::index
* @see app/Http/Controllers/Api/Translations/TranslationController.php:17
* @route '/api/translations'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Translations\TranslationController::index
* @see app/Http/Controllers/Api/Translations/TranslationController.php:17
* @route '/api/translations'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\Translations\BatchUpdateTranslationsController::__invoke
* @see app/Http/Controllers/Api/Translations/BatchUpdateTranslationsController.php:12
* @route '/api/translations/batch'
*/
export const batch = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: batch.url(options),
    method: 'post',
})

batch.definition = {
    methods: ["post"],
    url: '/api/translations/batch',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Translations\BatchUpdateTranslationsController::__invoke
* @see app/Http/Controllers/Api/Translations/BatchUpdateTranslationsController.php:12
* @route '/api/translations/batch'
*/
batch.url = (options?: RouteQueryOptions) => {
    return batch.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Translations\BatchUpdateTranslationsController::__invoke
* @see app/Http/Controllers/Api/Translations/BatchUpdateTranslationsController.php:12
* @route '/api/translations/batch'
*/
batch.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: batch.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Translations\MarkTranslationAsReviewedController::__invoke
* @see app/Http/Controllers/Api/Translations/MarkTranslationAsReviewedController.php:14
* @route '/api/translations/{language}/{key}/mark-reviewed'
*/
export const markReviewed = (args: { language: string | number, key: string | number } | [language: string | number, key: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: markReviewed.url(args, options),
    method: 'post',
})

markReviewed.definition = {
    methods: ["post"],
    url: '/api/translations/{language}/{key}/mark-reviewed',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Translations\MarkTranslationAsReviewedController::__invoke
* @see app/Http/Controllers/Api/Translations/MarkTranslationAsReviewedController.php:14
* @route '/api/translations/{language}/{key}/mark-reviewed'
*/
markReviewed.url = (args: { language: string | number, key: string | number } | [language: string | number, key: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            language: args[0],
            key: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        language: args.language,
        key: args.key,
    }

    return markReviewed.definition.url
            .replace('{language}', parsedArgs.language.toString())
            .replace('{key}', parsedArgs.key.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Translations\MarkTranslationAsReviewedController::__invoke
* @see app/Http/Controllers/Api/Translations/MarkTranslationAsReviewedController.php:14
* @route '/api/translations/{language}/{key}/mark-reviewed'
*/
markReviewed.post = (args: { language: string | number, key: string | number } | [language: string | number, key: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: markReviewed.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Translations\TranslationController::show
* @see app/Http/Controllers/Api/Translations/TranslationController.php:26
* @route '/api/translations/{language}/{key}'
*/
export const show = (args: { language: string | number, key: string | number } | [language: string | number, key: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/api/translations/{language}/{key}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Translations\TranslationController::show
* @see app/Http/Controllers/Api/Translations/TranslationController.php:26
* @route '/api/translations/{language}/{key}'
*/
show.url = (args: { language: string | number, key: string | number } | [language: string | number, key: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            language: args[0],
            key: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        language: args.language,
        key: args.key,
    }

    return show.definition.url
            .replace('{language}', parsedArgs.language.toString())
            .replace('{key}', parsedArgs.key.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Translations\TranslationController::show
* @see app/Http/Controllers/Api/Translations/TranslationController.php:26
* @route '/api/translations/{language}/{key}'
*/
show.get = (args: { language: string | number, key: string | number } | [language: string | number, key: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Translations\TranslationController::show
* @see app/Http/Controllers/Api/Translations/TranslationController.php:26
* @route '/api/translations/{language}/{key}'
*/
show.head = (args: { language: string | number, key: string | number } | [language: string | number, key: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\Translations\TranslationController::update
* @see app/Http/Controllers/Api/Translations/TranslationController.php:38
* @route '/api/translations/{language}/{key}'
*/
export const update = (args: { language: string | number, key: string | number } | [language: string | number, key: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/api/translations/{language}/{key}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Api\Translations\TranslationController::update
* @see app/Http/Controllers/Api/Translations/TranslationController.php:38
* @route '/api/translations/{language}/{key}'
*/
update.url = (args: { language: string | number, key: string | number } | [language: string | number, key: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            language: args[0],
            key: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        language: args.language,
        key: args.key,
    }

    return update.definition.url
            .replace('{language}', parsedArgs.language.toString())
            .replace('{key}', parsedArgs.key.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Translations\TranslationController::update
* @see app/Http/Controllers/Api/Translations/TranslationController.php:38
* @route '/api/translations/{language}/{key}'
*/
update.put = (args: { language: string | number, key: string | number } | [language: string | number, key: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

const translations = {
    sync: Object.assign(sync, sync),
    index: Object.assign(index, index),
    batch: Object.assign(batch, batch),
    markReviewed: Object.assign(markReviewed, markReviewed),
    show: Object.assign(show, show),
    update: Object.assign(update, update),
}

export default translations